import { useCallback } from "react";

interface InteractiveElementEventsProps<T> {
  onClick?: (event: React.MouseEvent<T>) => void;
  onKeyDown?: (event: React.KeyboardEvent<T>) => void;
  onKeyUp?: (event: React.KeyboardEvent<T>) => void;
}

export const useInteractiveElementEvents = <T>({ onClick, onKeyDown, onKeyUp }: InteractiveElementEventsProps<T>) => {
  const handleKeyDown = useCallback(
    (event: React.KeyboardEvent<T>) => {
      onKeyDown?.(event);
      if (event.target !== event.currentTarget) {
        return;
      }
      if (event.key === "Enter" || event.code === "Enter") {
        onClick?.(event as unknown as React.MouseEvent<T>);
      }
      if (onClick && (event.key === " " || event.code === "Space")) {
        event.preventDefault();
      }
    },
    [onClick, onKeyDown]
  );
  const handleKeyUp = useCallback(
    (event: React.KeyboardEvent<T>) => {
      onKeyUp?.(event);
      if (event.target !== event.currentTarget) {
        return;
      }
      if (event.key === " " || event.code === "Space") {
        onClick?.(event as unknown as React.MouseEvent<T>);
      }
    },
    [onClick, onKeyUp]
  );

  return { handleKeyDown, handleKeyUp };
};
